import { decodeJwt } from 'src/utils/parseJwtUtils';

/** An SSO session (JWT `amr: 'sso'`) signs in at its IdP: no password needed. */
const isSsoSession = (token: string): boolean => (decodeJwt(token) as { amr?: unknown } | null)?.amr === 'sso';

/** Logged-in sessions, including a handoff exchange, must set a password first. */
export const needsPasswordSetup = (token: string | null | undefined, user: { requiresPasswordSetup?: boolean } | null | undefined): boolean =>
  Boolean(token) && user?.requiresPasswordSetup === true && !isSsoSession(token as string);
